import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import { ScrollTrigger } from "../libraries/gsap"
import Marquee from "../components/Marquee"

export default class AnnouncementBar extends Component {
  constructor(obj) {
    super(obj)

    this.marqueeDOM = qs(".marquee", this.el)
  }

  on() {
    this.marquee = new Marquee(this.marqueeDOM)
  }
}
